import * as React from 'react';
export const useTimeout = (cb: () => void, delay: number) => {
  React.useEffect(() => {
    let timer = setTimeout(() => {
      if (typeof cb === 'function') {
        cb();
      }
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, []);
};
